import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewEncapsulation,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { Menu } from 'primeng/menu';
import { OverlayBadge } from 'primeng/overlaybadge';
import { SplitButtonModule } from 'primeng/splitbutton';

import { NgIconComponent } from '@ng-icons/core';

import { topToBottom } from '@animations/topToBottom.anim';

import { LoaderWrapperComponent } from '@components/loader-wrapper/loader-wrapper.component';
import { LogoutDialog } from '@layouts/dashboard/components/header/components/logout-dialog/logout-dialog.component';
import { NotificationsComponent } from '@layouts/dashboard/components/header/components/notifications/notifications.component';

import { LoaderState } from '@cxc/core/services';
import { UserStore } from '@cxc/core/services';
import { NavigationService } from '@services/navigation.service';
import { NotificationState } from '@services/state/notification.state';

import { humanizeISODate } from '@cxc/core/utils';

@Component({
  selector: 'dashboard-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,

    OverlayBadge,
    Menu,
    SplitButtonModule,

    NgIconComponent,

    LoaderWrapperComponent,
    LogoutDialog,
    NotificationsComponent,
  ],

  animations: [topToBottom],
})
export class DashboardHeaderComponent {
  loaderState = inject(LoaderState);

  menuItems: any[] = [];
  notificationItems: any[] = [];

  notificationButton = viewChild<ElementRef<HTMLElement>>('notificationButton');
  notificationMenuWidth = 475;

  notificationMenu = viewChild.required<Menu>('notificationMenu');

  unreadNotifications = signal(0);
  showLogoutDialog = signal(false);

  humanizeISODate = humanizeISODate;

  constructor(
    public locationService: NavigationService,
    public userStore: UserStore,
    public notificationStore: NotificationState,
    public activatedRoute: ActivatedRoute,
    public router: Router
  ) {
    this.menuItems = [
      {
        separator: true,
      },
      {
        label: 'Profile',
        icon: 'phosphorUser',
        iconClass: '!text-surface-900',
        action: () => router.navigateByUrl('/account/profile'),
      },
      {
        label: 'Log Out',
        icon: 'phosphorSignOut',
        iconClass: '!text-red-500',
        action: () => this.showLogoutDialog.set(true),
      },
    ];
  }
}
